import * as ItemUtils from '../../common/ItemTools';
import { buildMediaTypeNameMap } from '../../common/MediaTypes';

const typeNameMap = buildMediaTypeNameMap();

export function openCustomUrl(url) {
  window.open(url, '_blank');
}

/**
 * The card's derived display facts: media type with its label and color, and
 * the humanized published / created / reading-length strings. Absent facts are
 * left off the object rather than set empty, so callers test for presence.
 */
export function getItemMetrics(item) {
  const timePublishedMoment = item.timePublished
    && `${ItemUtils.convertUnixTimeToPublishedMoment(item.timePublished, item.timePublishedDateOnly)}`;
  const timeCreatedMoment = item.timeCreated
    && `${ItemUtils.convertUnixTimeToMoment(item.timeCreated)}`;
  const timeLeftMoment = item.timeNeeded
    && `${ItemUtils.humanizeIntervalInMinutes(item.timeNeeded)}`;
  const type = item.type && typeNameMap[item.type];
  const label = type && type.label;
  const color = (type && type.color) || 'gray';

  const result = {
    ...(type && { type }),
    ...(timePublishedMoment && { published: timePublishedMoment }),
    ...(timeCreatedMoment && { created: timeCreatedMoment }),
    ...(timeLeftMoment && { length: timeLeftMoment }),
    ...(label && { label }),
    ...(color && { color }),
  };

  return result;
}
